import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledNgInputCopyButton = styled.button`
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.linkHoverColor};
  background: ${({ theme }) => theme.palette.cardBackground};
  border: none;
  border-left: 1.5px solid ${({ theme }) => theme.palette.cardBorder};
  cursor: pointer;
  white-space: nowrap;
  padding: 8px 10px;
  font-family: inherit;

  &:hover {
    opacity: 0.75;
  }
`;

interface NgInputCopyButtonProps {
  text: string;
}

export const NgInputCopyButton: FC<NgInputCopyButtonProps> = ({ text }) => {
  const [label, setLabel] = useState('Copy');

  useEffect(() => {
    if (label !== 'Copied!') {
      return;
    }

    const timeout = setTimeout(() => setLabel('Copy'), 1500);

    return () => clearTimeout(timeout);
  }, [label]);

  return (
    <StyledNgInputCopyButton
      onClick={() => {
        navigator.clipboard.writeText(text);
        setLabel('Copied!');
      }}
    >
      {label}
    </StyledNgInputCopyButton>
  );
};
